const getters = {

  token: state => state.user.token,
  name: state => state.user.userInfo.username,
  status: state => state.user.userInfo.status,
  userInfo: state => state.user.userInfo,
  basicInfo: state => state.user.basicInfo,
  menus: state => state.user.menus,
  activeIndex: state => state.user.activeIndex,
  permission: state => state.user.permission,
  isClock: state => state.user.isClock,
  isAddE: state => state.user.isAddE,
  webscoketFun: state => state.user.webscoketFun
}
export default getters

